import React, { FC } from 'react';

import { Matches, UpdateStatus } from '../../../../../database.schema';
import { useCreateMatchMutation } from '../../../../api/tournament-data';
import { Button } from '../../../common-styles/common-styles';

type UpdateButtonProps = {
  selectedTournamentIndex: number;
  resultIndex: number;
  matches: Matches;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  setShowUpdate: (value: boolean) => void;
  disabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, resultIndex, matches, disabled, setUpdateStatus, setShowUpdate }) => {
  const mutation = useCreateMatchMutation();
  const saveCourse = () => {
    const dataToSave = { selectedTournamentIndex, resultIndex, matches };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            setShowUpdate(false);
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true, message: error.message, stack: error.stack ? error.stack : '' });
            console.log('<><><>ERROR<><><><', error);
          },
        }
      );
    }
  };
  return (
    <Button data-testid="save-button" onClick={() => saveCourse()} disabled={disabled}>
      Save
    </Button>
  );
};
